<template>
    <el-dialog title="Add/Update Activity" :visible.sync="activity_dialog_visible" width="60%">
        <el-row>
            <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
                <label class="font-bold block mt-2">Activity</label>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="16" :xl="16">
                <el-select
                    v-model="activity_name"
                    allow-create
                    filterable
                    default-first-option
                    size="small"
                    @change="handleActivityType()"
                >
                    <el-option
                        v-for="(act, store_activity_index) in activity_type_list"
                        :key="store_activity_index"
                        :value="act.id"
                        :label="act.name"
                    ></el-option>
                </el-select>
            </el-col>
        </el-row>

        <el-row class="mt-10">
            <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
                <label class="font-bold">Applicable For</label>
            </el-col>

            <el-col :xs="24" :sm="24" :md="12" :lg="16" :xl="16">
                <div class="flex items-center flex-wrap">
                    <div>
                        <el-checkbox
                            v-model="all_store_type"
                            :disabled="dine_in || restroom || drive_through || delivery"
                            @change="setAllStoreType()"
                        >All Store</el-checkbox>
                    </div>
                    <div class="ml-2">
                        <el-checkbox
                            v-model="dine_in"
                            :disabled="all_store_type"
                            @change="setActivityType()"
                        >Dine In</el-checkbox>
                    </div>
                    <div class="ml-2">
                        <el-checkbox
                            v-model="restroom"
                            :disabled="all_store_type"
                            @change="setActivityType()"
                        >Rest Room</el-checkbox>
                    </div>
                    <div class="ml-2">
                        <el-checkbox
                            v-model="drive_through"
                            :disabled="all_store_type"
                            @change="setActivityType()"
                        >Drive Through</el-checkbox>
                    </div>
                    <div class="ml-2">
                        <el-checkbox
                            v-model="delivery"
                            :disabled="all_store_type"
                            @change="setActivityType()"
                        >Delivery</el-checkbox>
                    </div>
                </div>
            </el-col>
        </el-row>

        <span slot="footer" class="dialog-footer">
            <el-button
                size="mini"
                @click="clearAddActivityDialogInputs(); activity_dialog_visible = false;"
            >Cancel</el-button>

            <!-- to delete selected activity -->
            <el-button
                v-if="Object.keys(selected_activity).length && selected_activity.activity"
                size="mini"
                @click="deleteAcitivityType();"
            >Delete</el-button>

            <el-button
                type="warning"
                size="mini"
                :disabled="!activity_name || (!all_store_type && !dine_in && !restroom && !drive_through && !delivery)"
                :loading="is_add_activity_in_progress"
                @click="saveActivityType()"
            >Update</el-button>
        </span>
    </el-dialog>
</template>

<script>
import settingsMixin from "../../../../../../mixins/settingsMixin";
export default {
    name: "AddUpdateActivity",
    mixins: [settingsMixin]
}
</script>